import client from "../client";
import { AssetTypeInterface } from "../../models/AssetModel/AssetType";

class AssetTypesService {
  async GetAll(page: number, pageSize: number) {
    try {
      let url = `/api/AssetTypes`;
      if (page > 0 && pageSize > 0) {
        url += `?page=${page}&pageSize=${pageSize}`;
      }
      const { data } = await client.get<AssetTypeInterface[]>(url);
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async GetById(id: string) {
    try {
      let url = `/api/AssetTypes/getbyid/${id}`;

      const { data } = await client.get<AssetTypeInterface>(url);

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async Save(customer: AssetTypeInterface) {
    try {
      let url = `/api/AssetTypes`;

      const { data } = await client.post<AssetTypeInterface>(url, customer);

      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async Update(id: string, customer: AssetTypeInterface) {
    try {
      let url = `/api/AssetTypes/update/${id}`;

      const { data } = await client.post<AssetTypeInterface>(url, customer);

      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
  async Remove(id: string) {
    try {
      let url = `api/AssetTypes/remove/${id}`;
      await client.post<AssetTypeInterface>(url, { url: "" });
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
}

export default new AssetTypesService();
